import defaultCurrencies from '../../currencies.json';

class CurrencyService {
  constructor(Restangular, $rootScope) {
    'ngInject';

    Object.assign(this, { Restangular, defaultCurrencies, $rootScope });
  }

  async setOrgCurrency(currencyCode) {
    this.selectedCurrency = await this.getCurrencyByCode(currencyCode);
    this.$rootScope.currencySymbol = this.selectedCurrency.symbol;
  }

  getOrgCurrency() {
    return this.selectedCurrency || this.getDefaultCurrency();
  }

  getDefaultCurrencies() {
    return defaultCurrencies;
  }

  getDefaultCurrency() {
    if (!this._defaultCurrency) {
      this._defaultCurrency = defaultCurrencies.find((item) => item.default);
    }

    return this._defaultCurrency;
  }

  async getAllCurrencies() {
    if (!this.currencies) {
      this.currencies = await this.Restangular.one('currencies').get();
    }

    return this.currencies;
  }

  async getCurrencyByCode(currencyCode) {
    let selected;
    selected = this._findCurrencyByCode(this.defaultCurrencies, currencyCode);

    if (!selected) {
      const fullList = await this.getAllCurrencies();
      selected = this._findCurrencyByCode(fullList, currencyCode);

      if (selected) {
        this.defaultCurrencies.push(selected);
      } else {
        return this.getDefaultCurrency();
      }
    }

    return selected;
  }

  _findCurrencyByCode(currencies, code) {
    return currencies.find((item) => item.code === code);
  }
}

export default CurrencyService;
